import {
  FETCH_CONTACT_REQUEST,
  FETCH_CONTACT_SUCCESS,
  FETCH_CONTACT_FAILURE,
  FETCH_RESUME_REQUEST,
  FETCH_RESUME_SUCCESS,
  FETCH_RESUME_FAILURE,
  DELETE_MESSAGE_REQUEST,
  DELETE_MESSAGE_SUCCESS,
  DELETE_MESSAGE_FAILURE,
} from "../actions/WebAdminActions";

const initialState = {
  contacts: [],
  resumes: [],
  loading: false,
  error: null,
  success: false,
};
const WebAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONTACT_REQUEST:
    case FETCH_RESUME_REQUEST:
    case DELETE_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case FETCH_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        contacts: action.payload,
      };

    case FETCH_RESUME_SUCCESS:
      return {
        ...state,
        loading: false,
        resumes: action.payload,
      };

    case DELETE_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        contacts: state.contacts.filter((c) => c.id !== action.payload),
        resumes: state.resumes.filter((r) => r.id !== action.payload),
      };

    case FETCH_CONTACT_FAILURE:
    case FETCH_RESUME_FAILURE:
    case DELETE_MESSAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default WebAdminReducer;
